import { GetJobsQuery, ProcessingStatus } from '@shared/generated/graphql';
import { useEffect } from 'react';

const POLL_INTERVAL_FREQUENT_SECONDS = 3 * 1000;
const POLL_INTERVAL_INFREQUENT_SECONDS = 30 * 1000;

const anyJobsInProgress = (jobEdges: GetJobsQuery['jobs']['edges']) => {
  return jobEdges.some((job) =>
    [ProcessingStatus.PROCESSING, ProcessingStatus.NEW].includes(
      job.node.status
    )
  );
};

export const useJobPolling = ({
  data,
  startPolling,
  stopPolling,
}: {
  data?: GetJobsQuery;
  startPolling: (interval: number) => void;
  stopPolling: () => void;
}) => {
  useEffect(() => {
    const jobEdges = data?.jobs.edges;
    if (jobEdges) {
      const shouldPollFrequently = anyJobsInProgress(jobEdges);
      if (shouldPollFrequently) {
        startPolling(POLL_INTERVAL_FREQUENT_SECONDS);
      } else {
        startPolling(POLL_INTERVAL_INFREQUENT_SECONDS);
      }
    }
    return () => {
      stopPolling();
    };
  }, [data, startPolling, stopPolling]);
};
